import React, { Component } from 'react';

class Projects extends React.Component {

	render() {
		return (
			<div> 
	
			<h2 >Study of Bayesian Neural Network</h2>

			<p>•	Surveyed various sampling (MCMC family, NUTS) & inference (Variational Inference) techniques to compute the posterior distribution over the parameters of model, not being limited to point estimation and need for regularization as in Neural Net</p>
			<p>•	Predicted Powerball number with results comparable to AdaBoost, Gaussian process classifiers along-with the uncertainty in the model using Probabilistic Programming approach limited in Neural Net</p>
			<p>•	Forecasted S&P 500 stock price more accurately than ARIMA model in addition to the estimation of uncertainty in predictions</p>
		
			<hr/>
			<h2>Predict ETF stock market movement using News Articles and Twitter</h2>
			<p>•	Developed MapReduce functions with Hive to batch process the real-time data from twitter, News forums and Yahoo! finance</p>
			<p>•	Trained Logistic Regression and Random Forest models maintaining temporality of data with predictive accuracy of 78.33% </p>
			<p>•	Used NLP: Sentiment & emoji analysis (self-built) on tweets and extracted ontologies from news articles using Topic Modeling</p>
			<p>•	Presented the project as a co-guest speaker in NYAI meet up with an audience of ~60 people</p>
			<hr/>
			
			<h2>Technical & Fundamental Analysis of S&P 500 Companies using Spark</h2>
			<p>•	Built ETL layer for ingesting data from Yahoo! Finance, NASDAQ, EDGAR SEC using Spark SQL</p>
			<p>•	Trained ARIMA (time-series) model to forecast stock price on rolling basis; Used spark-TS to minimize shuffle across network</p>
			<p>•	Discovered increasing trend in IT sector across 10 years based on Top-20 performing companies, evaluated using ROI, Cash Ratio</p>
		
			</div>
			);
	 }
	 } 

export default Projects;


// WEBPACK FOOTER //
// ./src/writeups/projects.js